export default function SelectedQuestionsBar({ selectedCount }) {

  return (

    <div style={{marginTop:"50px",display:"flex",justifyContent:"center",alignItems:"center"}}>

      <b style={{position:"relative",display:"flex",justifyContent:"center",alignItems:"center",fontSize:"20px",padding:"10px",color:"#222222",background:"rgba(144, 202, 249,0.41)",border:"0px",borderRadius:"15px",cursor:"pointer",zIndex:99999,height:"55px"}}>
        Selected Questions: {selectedCount}
      </b>

    </div>

  );

}